export const Doamin_url = `${window.location.origin}/`;




// export const base_url = `http://localhost:5001/`;
// export const soket_url = `http://localhost:5001/`;
// export const image_baseurl = `https://stockbox.pnpuniverse.com/`;


// export const base_url = `${window.location.origin}/backend/`
// export const soket_url = `${window.location.origin}:1001/`;
// export const image_baseurl = `${window.location.origin}/`  




const isLocalhost = window.location.hostname === "localhost";

export const base_url = isLocalhost
    ? "http://localhost:5001/"
    : `${window.location.origin}/backend/`;

export const soket_url = isLocalhost
    ? "http://localhost:5001/"
    : `${window.location.origin}:1001/`;

export const image_baseurl = isLocalhost
    ? "https://stockbox.pnpuniverse.com/"
    : `${window.location.origin}/`;
